<template>
  <div class="user-list">
    <div class="search-bar">
      <el-input v-model="searchParam.keyword_search" placeholder="请输入关键词搜索"></el-input>
      <el-button type="primary" @click="getList('clear')">搜索</el-button>
      <el-button @click="resetSearch">重置</el-button>
      <!-- <el-button @click="exportLearn">学习进度导出</el-button> -->
    </div>
    <div class="table">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="user_id" label="用户id" width="180"> </el-table-column>
        <el-table-column prop="real_name" label="用户姓名" width="180" align="center"> </el-table-column>
        <el-table-column prop="mobile" label="注册手机号" width="180"> </el-table-column>
        <el-table-column prop="create_time" label="注册时间" width="180"> </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button class="mid-blue" @click="toDetail(scope.row)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          :current-page="page_index"
          :page-sizes="[10, 20, 60, 100]"
          :page-size="page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserList, learnExport } from "@/api/user.js";
import { exportLearn } from "@/api/edu.js";
import { mixin } from "@/mixins/pagination.js";
export default {
  mixins: [mixin],
  data() {
    return {
      searchParam: {
        keyword_search: "",
        page_index: 1,

        page_size: 10,
      },
      tableData: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    exportLearn() {
      const param = {
        page_index: this.page_index,
        page_size: this.page_size,
        ...this.searchParam,
      };
      exportLearn(param);
    },
    resetSearch() {
      this.searchParam = {};
      this.getList();
    },
    toDetail(row) {
      console.log(row);
      this.$router.push({ path: "/user-detail", query: row });
    },
    async getList(type) {
      if (type === "clear") {
        this.page_index = 1;
        this.page_size = 10;
      }
      const res = await getUserList({
        ...this.searchParam,
        page_index: this.page_index,
        page_size: this.page_size,
      });
      if (res.data instanceof Array) {
        this.tableData = res.data;
        this.total = res.total;
      }
      console.log(res);
    },
  },
};
</script>

<style scoped="scoped">
.user-list {
  background: white;
  padding: 10px;
  box-sizing: border-box;
}
</style>
